package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Serbia Flag (16x12dp)
 *
 * - ISO Alpha-2: RS
 * - ISO Alpha-3: SRB
 * - ISO Numeric: 688
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Serbia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Serbia:RS:SRB:688:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4857A1)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(4f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 8f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(8f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6C540)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.26f, 1.348f)
                lineTo(5.196f, 1.104f)
                curveTo(5.249f, 1.119f, 5.306f, 1.135f, 5.367f, 1.151f)
                lineTo(5.365f, 1.142f)
                curveTo(6.119f, 1.212f, 7.287f, 1.588f, 7.507f, 1.981f)
                curveTo(7.592f, 2.132f, 7.509f, 2.261f, 7.401f, 2.429f)
                lineTo(7.401f, 2.429f)
                curveTo(7.385f, 2.454f, 7.369f, 2.48f, 7.352f, 2.507f)
                curveTo(7.297f, 2.595f, 7.248f, 2.678f, 7.202f, 2.757f)
                curveTo(7.033f, 3.045f, 6.901f, 3.269f, 6.697f, 3.381f)
                lineTo(6.701f, 4.02f)
                lineTo(3.332f, 3.993f)
                lineTo(3.328f, 3.349f)
                curveTo(3.153f, 3.229f, 3.03f, 3.02f, 2.876f, 2.758f)
                lineTo(2.876f, 2.758f)
                curveTo(2.83f, 2.679f, 2.781f, 2.595f, 2.727f, 2.508f)
                curveTo(2.71f, 2.48f, 2.693f, 2.454f, 2.677f, 2.429f)
                curveTo(2.569f, 2.261f, 2.487f, 2.133f, 2.571f, 1.981f)
                curveTo(2.737f, 1.685f, 3.484f, 1.392f, 4.164f, 1.237f)
                curveTo(4.292f, 1.194f, 4.426f, 1.154f, 4.558f, 1.116f)
                lineTo(4.613f, 1.153f)
                curveTo(4.672f, 1.145f, 4.729f, 1.138f, 4.783f, 1.133f)
                lineTo(4.864f, 1.304f)
                horizontalLineTo(5.127f)
                curveTo(5.127f, 1.304f, 5.293f, 1.768f, 5.293f, 2.025f)
                curveTo(5.293f, 2.282f, 5.127f, 2.495f, 5.127f, 2.495f)
                verticalLineTo(2.673f)
                curveTo(5.156f, 2.675f, 5.186f, 2.678f, 5.218f, 2.681f)
                curveTo(5.218f, 2.665f, 5.219f, 2.649f, 5.222f, 2.632f)
                curveTo(5.237f, 2.547f, 5.286f, 2.485f, 5.331f, 2.493f)
                curveTo(5.376f, 2.5f, 5.4f, 2.576f, 5.385f, 2.661f)
                curveTo(5.383f, 2.674f, 5.38f, 2.687f, 5.376f, 2.699f)
                curveTo(5.553f, 2.722f, 5.752f, 2.754f, 5.941f, 2.786f)
                curveTo(6.013f, 2.655f, 6.1f, 2.526f, 6.184f, 2.402f)
                lineTo(6.184f, 2.402f)
                curveTo(6.4f, 2.082f, 6.59f, 1.801f, 6.413f, 1.633f)
                curveTo(6.379f, 1.601f, 6.318f, 1.572f, 6.238f, 1.544f)
                curveTo(5.978f, 1.481f, 5.694f, 1.432f, 5.419f, 1.406f)
                lineTo(5.411f, 1.37f)
                curveTo(5.359f, 1.362f, 5.308f, 1.355f, 5.26f, 1.348f)
                close()
                moveTo(6.542f, 2.899f)
                curveTo(6.637f, 2.918f, 6.694f, 2.929f, 6.694f, 2.929f)
                lineTo(6.695f, 3.028f)
                curveTo(7.029f, 2.79f, 7.263f, 2.249f, 7.283f, 2.073f)
                curveTo(7.295f, 1.968f, 7.12f, 1.845f, 6.844f, 1.734f)
                curveTo(6.97f, 1.968f, 6.794f, 2.202f, 6.573f, 2.494f)
                curveTo(6.489f, 2.605f, 6.399f, 2.724f, 6.317f, 2.855f)
                lineTo(6.4f, 2.871f)
                curveTo(6.399f, 2.846f, 6.402f, 2.818f, 6.409f, 2.79f)
                curveTo(6.432f, 2.706f, 6.485f, 2.648f, 6.53f, 2.66f)
                curveTo(6.574f, 2.672f, 6.592f, 2.749f, 6.569f, 2.832f)
                curveTo(6.563f, 2.857f, 6.553f, 2.88f, 6.542f, 2.899f)
                close()
                moveTo(4.819f, 2.674f)
                verticalLineTo(2.476f)
                curveTo(4.819f, 2.476f, 4.676f, 2.325f, 4.653f, 2.011f)
                curveTo(4.637f, 1.782f, 4.689f, 1.512f, 4.718f, 1.382f)
                curveTo(4.517f, 1.407f, 4.307f, 1.445f, 4.101f, 1.492f)
                curveTo(3.936f, 1.533f, 3.803f, 1.58f, 3.746f, 1.633f)
                curveTo(3.569f, 1.801f, 3.759f, 2.082f, 3.975f, 2.402f)
                curveTo(4.056f, 2.521f, 4.14f, 2.646f, 4.211f, 2.773f)
                curveTo(4.332f, 2.748f, 4.455f, 2.725f, 4.569f, 2.707f)
                curveTo(4.564f, 2.69f, 4.561f, 2.672f, 4.559f, 2.653f)
                curveTo(4.551f, 2.568f, 4.582f, 2.495f, 4.628f, 2.491f)
                curveTo(4.673f, 2.487f, 4.716f, 2.553f, 4.724f, 2.639f)
                curveTo(4.725f, 2.655f, 4.725f, 2.67f, 4.724f, 2.685f)
                curveTo(4.757f, 2.68f, 4.789f, 2.677f, 4.819f, 2.674f)
                close()
                moveTo(3.841f, 2.854f)
                curveTo(3.759f, 2.723f, 3.669f, 2.604f, 3.586f, 2.494f)
                lineTo(3.586f, 2.494f)
                curveTo(3.36f, 2.195f, 3.181f, 1.957f, 3.324f, 1.717f)
                curveTo(3.001f, 1.838f, 2.783f, 1.968f, 2.795f, 2.073f)
                curveTo(2.814f, 2.24f, 3.022f, 2.728f, 3.326f, 2.984f)
                lineTo(3.326f, 2.98f)
                curveTo(3.326f, 2.98f, 3.449f, 2.947f, 3.633f, 2.903f)
                curveTo(3.62f, 2.885f, 3.61f, 2.863f, 3.602f, 2.838f)
                curveTo(3.575f, 2.756f, 3.589f, 2.678f, 3.632f, 2.664f)
                curveTo(3.676f, 2.65f, 3.733f, 2.705f, 3.759f, 2.787f)
                curveTo(3.769f, 2.816f, 3.773f, 2.844f, 3.773f, 2.87f)
                lineTo(3.841f, 2.854f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.297f, 1.342f)
                curveTo(4.32f, 1.358f, 4.348f, 1.367f, 4.379f, 1.367f)
                curveTo(4.456f, 1.367f, 4.519f, 1.308f, 4.519f, 1.235f)
                curveTo(4.519f, 1.163f, 4.456f, 1.103f, 4.379f, 1.103f)
                curveTo(4.324f, 1.103f, 4.277f, 1.133f, 4.254f, 1.176f)
                curveTo(4.231f, 1.161f, 4.202f, 1.151f, 4.171f, 1.151f)
                curveTo(4.122f, 1.151f, 4.079f, 1.175f, 4.054f, 1.212f)
                curveTo(4.03f, 1.193f, 3.999f, 1.181f, 3.965f, 1.181f)
                curveTo(3.887f, 1.181f, 3.825f, 1.241f, 3.825f, 1.313f)
                curveTo(3.825f, 1.317f, 3.825f, 1.321f, 3.825f, 1.325f)
                curveTo(3.8f, 1.295f, 3.76f, 1.276f, 3.716f, 1.276f)
                curveTo(3.646f, 1.276f, 3.588f, 1.325f, 3.578f, 1.388f)
                curveTo(3.552f, 1.357f, 3.513f, 1.338f, 3.468f, 1.338f)
                curveTo(3.401f, 1.338f, 3.345f, 1.382f, 3.331f, 1.442f)
                curveTo(3.308f, 1.426f, 3.28f, 1.417f, 3.249f, 1.417f)
                curveTo(3.187f, 1.417f, 3.135f, 1.455f, 3.116f, 1.508f)
                curveTo(3.098f, 1.499f, 3.076f, 1.494f, 3.054f, 1.494f)
                curveTo(2.985f, 1.494f, 2.927f, 1.541f, 2.916f, 1.603f)
                curveTo(2.907f, 1.601f, 2.898f, 1.6f, 2.888f, 1.6f)
                curveTo(2.812f, 1.6f, 2.749f, 1.658f, 2.748f, 1.73f)
                curveTo(2.74f, 1.729f, 2.731f, 1.728f, 2.723f, 1.728f)
                curveTo(2.645f, 1.728f, 2.583f, 1.787f, 2.583f, 1.86f)
                curveTo(2.583f, 1.869f, 2.584f, 1.878f, 2.585f, 1.887f)
                curveTo(2.576f, 1.885f, 2.567f, 1.884f, 2.557f, 1.884f)
                curveTo(2.48f, 1.884f, 2.417f, 1.943f, 2.417f, 2.016f)
                curveTo(2.417f, 2.071f, 2.453f, 2.118f, 2.504f, 2.138f)
                curveTo(2.501f, 2.149f, 2.5f, 2.16f, 2.5f, 2.172f)
                curveTo(2.5f, 2.227f, 2.536f, 2.275f, 2.587f, 2.294f)
                curveTo(2.584f, 2.305f, 2.583f, 2.316f, 2.583f, 2.328f)
                curveTo(2.583f, 2.399f, 2.642f, 2.457f, 2.717f, 2.46f)
                curveTo(2.686f, 2.484f, 2.665f, 2.521f, 2.665f, 2.562f)
                curveTo(2.665f, 2.635f, 2.728f, 2.694f, 2.805f, 2.694f)
                curveTo(2.883f, 2.694f, 2.945f, 2.635f, 2.945f, 2.562f)
                curveTo(2.945f, 2.491f, 2.886f, 2.433f, 2.811f, 2.43f)
                curveTo(2.842f, 2.406f, 2.862f, 2.369f, 2.862f, 2.328f)
                curveTo(2.862f, 2.273f, 2.826f, 2.225f, 2.775f, 2.206f)
                curveTo(2.778f, 2.195f, 2.78f, 2.183f, 2.78f, 2.172f)
                curveTo(2.78f, 2.116f, 2.743f, 2.069f, 2.692f, 2.049f)
                curveTo(2.695f, 2.039f, 2.697f, 2.027f, 2.697f, 2.016f)
                curveTo(2.697f, 2.006f, 2.696f, 1.997f, 2.694f, 1.989f)
                curveTo(2.703f, 1.991f, 2.713f, 1.992f, 2.723f, 1.992f)
                curveTo(2.799f, 1.992f, 2.861f, 1.934f, 2.862f, 1.862f)
                curveTo(2.871f, 1.863f, 2.879f, 1.864f, 2.888f, 1.864f)
                curveTo(2.957f, 1.864f, 3.015f, 1.817f, 3.026f, 1.755f)
                curveTo(3.035f, 1.757f, 3.044f, 1.757f, 3.054f, 1.757f)
                curveTo(3.116f, 1.757f, 3.168f, 1.719f, 3.187f, 1.667f)
                curveTo(3.206f, 1.676f, 3.227f, 1.681f, 3.249f, 1.681f)
                curveTo(3.28f, 1.681f, 3.308f, 1.671f, 3.332f, 1.656f)
                curveTo(3.336f, 1.673f, 3.344f, 1.689f, 3.355f, 1.704f)
                curveTo(3.338f, 1.725f, 3.328f, 1.752f, 3.328f, 1.782f)
                curveTo(3.328f, 1.853f, 3.388f, 1.911f, 3.462f, 1.913f)
                curveTo(3.431f, 1.938f, 3.411f, 1.974f, 3.411f, 2.016f)
                curveTo(3.411f, 2.071f, 3.447f, 2.118f, 3.498f, 2.138f)
                curveTo(3.495f, 2.149f, 3.494f, 2.16f, 3.494f, 2.172f)
                curveTo(3.494f, 2.227f, 3.53f, 2.275f, 3.581f, 2.294f)
                curveTo(3.578f, 2.305f, 3.576f, 2.316f, 3.576f, 2.328f)
                curveTo(3.576f, 2.401f, 3.639f, 2.46f, 3.716f, 2.46f)
                curveTo(3.794f, 2.46f, 3.856f, 2.401f, 3.856f, 2.328f)
                curveTo(3.856f, 2.273f, 3.82f, 2.225f, 3.769f, 2.206f)
                curveTo(3.772f, 2.195f, 3.773f, 2.183f, 3.773f, 2.172f)
                curveTo(3.773f, 2.116f, 3.737f, 2.069f, 3.686f, 2.049f)
                curveTo(3.689f, 2.039f, 3.691f, 2.027f, 3.691f, 2.016f)
                curveTo(3.691f, 1.945f, 3.631f, 1.887f, 3.556f, 1.884f)
                curveTo(3.588f, 1.86f, 3.608f, 1.823f, 3.608f, 1.782f)
                curveTo(3.608f, 1.752f, 3.598f, 1.725f, 3.581f, 1.704f)
                curveTo(3.598f, 1.682f, 3.608f, 1.655f, 3.608f, 1.626f)
                curveTo(3.608f, 1.596f, 3.598f, 1.569f, 3.581f, 1.547f)
                curveTo(3.594f, 1.531f, 3.603f, 1.511f, 3.606f, 1.49f)
                curveTo(3.632f, 1.52f, 3.672f, 1.54f, 3.716f, 1.54f)
                curveTo(3.794f, 1.54f, 3.856f, 1.481f, 3.856f, 1.408f)
                curveTo(3.856f, 1.404f, 3.856f, 1.4f, 3.856f, 1.396f)
                curveTo(3.881f, 1.426f, 3.921f, 1.445f, 3.965f, 1.445f)
                curveTo(4.014f, 1.445f, 4.057f, 1.421f, 4.082f, 1.385f)
                curveTo(4.107f, 1.404f, 4.138f, 1.415f, 4.171f, 1.415f)
                curveTo(4.226f, 1.415f, 4.274f, 1.385f, 4.297f, 1.342f)
                close()
                moveTo(3.468f, 1.601f)
                curveTo(3.514f, 1.601f, 3.555f, 1.58f, 3.581f, 1.547f)
                curveTo(3.555f, 1.515f, 3.514f, 1.494f, 3.468f, 1.494f)
                curveTo(3.482f, 1.494f, 3.494f, 1.483f, 3.494f, 1.469f)
                curveTo(3.494f, 1.456f, 3.482f, 1.445f, 3.468f, 1.445f)
                curveTo(3.454f, 1.445f, 3.442f, 1.456f, 3.442f, 1.469f)
                curveTo(3.442f, 1.483f, 3.454f, 1.494f, 3.468f, 1.494f)
                curveTo(3.437f, 1.494f, 3.409f, 1.503f, 3.386f, 1.519f)
                curveTo(3.378f, 1.487f, 3.358f, 1.46f, 3.331f, 1.442f)
                curveTo(3.329f, 1.451f, 3.328f, 1.46f, 3.328f, 1.469f)
                curveTo(3.328f, 1.499f, 3.338f, 1.526f, 3.355f, 1.547f)
                curveTo(3.338f, 1.569f, 3.328f, 1.596f, 3.328f, 1.626f)
                curveTo(3.328f, 1.636f, 3.329f, 1.646f, 3.332f, 1.656f)
                curveTo(3.359f, 1.637f, 3.379f, 1.609f, 3.386f, 1.577f)
                curveTo(3.409f, 1.592f, 3.437f, 1.601f, 3.468f, 1.601f)
                close()
                moveTo(3.468f, 1.65f)
                curveTo(3.422f, 1.65f, 3.381f, 1.671f, 3.355f, 1.704f)
                curveTo(3.381f, 1.736f, 3.422f, 1.757f, 3.468f, 1.757f)
                curveTo(3.514f, 1.757f, 3.555f, 1.736f, 3.581f, 1.704f)
                curveTo(3.555f, 1.671f, 3.514f, 1.65f, 3.468f, 1.65f)
                close()
                moveTo(3.468f, 1.65f)
                curveTo(3.482f, 1.65f, 3.494f, 1.639f, 3.494f, 1.626f)
                curveTo(3.494f, 1.612f, 3.482f, 1.601f, 3.468f, 1.601f)
                curveTo(3.454f, 1.601f, 3.442f, 1.612f, 3.442f, 1.626f)
                curveTo(3.442f, 1.639f, 3.454f, 1.65f, 3.468f, 1.65f)
                close()
                moveTo(3.386f, 1.577f)
                curveTo(3.374f, 1.568f, 3.364f, 1.559f, 3.355f, 1.547f)
                curveTo(3.364f, 1.536f, 3.374f, 1.527f, 3.386f, 1.519f)
                curveTo(3.388f, 1.528f, 3.389f, 1.538f, 3.389f, 1.549f)
                curveTo(3.389f, 1.558f, 3.388f, 1.568f, 3.386f, 1.577f)
                close()
                moveTo(3.769f, 2.206f)
                curveTo(3.753f, 2.199f, 3.735f, 2.196f, 3.716f, 2.196f)
                curveTo(3.651f, 2.196f, 3.597f, 2.238f, 3.581f, 2.294f)
                curveTo(3.597f, 2.3f, 3.615f, 2.304f, 3.633f, 2.304f)
                curveTo(3.698f, 2.304f, 3.753f, 2.262f, 3.769f, 2.206f)
                close()
                moveTo(3.686f, 2.049f)
                curveTo(3.67f, 2.043f, 3.652f, 2.04f, 3.633f, 2.04f)
                curveTo(3.569f, 2.04f, 3.514f, 2.082f, 3.498f, 2.138f)
                curveTo(3.514f, 2.144f, 3.532f, 2.148f, 3.551f, 2.148f)
                curveTo(3.616f, 2.148f, 3.67f, 2.106f, 3.686f, 2.049f)
                close()
                moveTo(3.556f, 1.884f)
                lineTo(3.551f, 1.884f)
                curveTo(3.517f, 1.884f, 3.486f, 1.895f, 3.462f, 1.913f)
                lineTo(3.468f, 1.913f)
                curveTo(3.501f, 1.913f, 3.532f, 1.902f, 3.556f, 1.884f)
                close()
                moveTo(2.811f, 2.43f)
                lineTo(2.805f, 2.43f)
                curveTo(2.772f, 2.43f, 2.741f, 2.441f, 2.717f, 2.46f)
                lineTo(2.723f, 2.46f)
                curveTo(2.756f, 2.46f, 2.787f, 2.449f, 2.811f, 2.43f)
                close()
                moveTo(2.775f, 2.206f)
                curveTo(2.759f, 2.262f, 2.705f, 2.304f, 2.64f, 2.304f)
                curveTo(2.621f, 2.304f, 2.603f, 2.3f, 2.587f, 2.294f)
                curveTo(2.603f, 2.238f, 2.658f, 2.196f, 2.723f, 2.196f)
                curveTo(2.741f, 2.196f, 2.759f, 2.199f, 2.775f, 2.206f)
                close()
                moveTo(2.692f, 2.049f)
                curveTo(2.676f, 2.106f, 2.622f, 2.148f, 2.557f, 2.148f)
                curveTo(2.538f, 2.148f, 2.521f, 2.144f, 2.504f, 2.138f)
                curveTo(2.52f, 2.082f, 2.575f, 2.04f, 2.64f, 2.04f)
                curveTo(2.658f, 2.04f, 2.676f, 2.043f, 2.692f, 2.049f)
                close()
                moveTo(2.585f, 1.887f)
                curveTo(2.597f, 1.938f, 2.64f, 1.978f, 2.694f, 1.989f)
                curveTo(2.683f, 1.938f, 2.64f, 1.897f, 2.585f, 1.887f)
                close()
                moveTo(2.862f, 1.862f)
                curveTo(2.797f, 1.85f, 2.748f, 1.797f, 2.748f, 1.732f)
                lineTo(2.748f, 1.73f)
                curveTo(2.813f, 1.741f, 2.862f, 1.795f, 2.862f, 1.86f)
                lineTo(2.862f, 1.862f)
                close()
                moveTo(3.026f, 1.755f)
                curveTo(2.962f, 1.743f, 2.914f, 1.689f, 2.914f, 1.626f)
                curveTo(2.914f, 1.618f, 2.915f, 1.61f, 2.916f, 1.603f)
                curveTo(2.98f, 1.615f, 3.028f, 1.668f, 3.028f, 1.732f)
                curveTo(3.028f, 1.74f, 3.027f, 1.747f, 3.026f, 1.755f)
                close()
                moveTo(3.187f, 1.667f)
                curveTo(3.141f, 1.645f, 3.109f, 1.6f, 3.109f, 1.549f)
                curveTo(3.109f, 1.534f, 3.112f, 1.52f, 3.116f, 1.508f)
                curveTo(3.162f, 1.529f, 3.194f, 1.574f, 3.194f, 1.626f)
                curveTo(3.194f, 1.64f, 3.191f, 1.654f, 3.187f, 1.667f)
                close()
                moveTo(3.606f, 1.49f)
                curveTo(3.588f, 1.467f, 3.576f, 1.439f, 3.576f, 1.408f)
                curveTo(3.576f, 1.401f, 3.577f, 1.395f, 3.578f, 1.388f)
                curveTo(3.597f, 1.41f, 3.608f, 1.439f, 3.608f, 1.469f)
                curveTo(3.608f, 1.476f, 3.607f, 1.483f, 3.606f, 1.49f)
                close()
                moveTo(3.825f, 1.325f)
                curveTo(3.828f, 1.352f, 3.839f, 1.376f, 3.856f, 1.396f)
                curveTo(3.853f, 1.369f, 3.842f, 1.345f, 3.825f, 1.325f)
                close()
                moveTo(4.082f, 1.385f)
                curveTo(4.051f, 1.361f, 4.031f, 1.324f, 4.031f, 1.283f)
                curveTo(4.031f, 1.257f, 4.04f, 1.232f, 4.054f, 1.212f)
                curveTo(4.085f, 1.236f, 4.105f, 1.272f, 4.105f, 1.313f)
                curveTo(4.105f, 1.34f, 4.096f, 1.364f, 4.082f, 1.385f)
                close()
                moveTo(4.297f, 1.342f)
                curveTo(4.262f, 1.318f, 4.239f, 1.279f, 4.239f, 1.235f)
                curveTo(4.239f, 1.214f, 4.244f, 1.194f, 4.254f, 1.176f)
                curveTo(4.289f, 1.2f, 4.311f, 1.239f, 4.311f, 1.283f)
                curveTo(4.311f, 1.304f, 4.306f, 1.324f, 4.297f, 1.342f)
                close()
                moveTo(2.888f, 1.756f)
                curveTo(2.902f, 1.756f, 2.914f, 1.745f, 2.914f, 1.732f)
                curveTo(2.914f, 1.719f, 2.902f, 1.708f, 2.888f, 1.708f)
                curveTo(2.874f, 1.708f, 2.862f, 1.719f, 2.862f, 1.732f)
                curveTo(2.862f, 1.745f, 2.874f, 1.756f, 2.888f, 1.756f)
                close()
                moveTo(2.723f, 1.884f)
                curveTo(2.737f, 1.884f, 2.748f, 1.873f, 2.748f, 1.86f)
                curveTo(2.748f, 1.846f, 2.737f, 1.835f, 2.723f, 1.835f)
                curveTo(2.708f, 1.835f, 2.697f, 1.846f, 2.697f, 1.86f)
                curveTo(2.697f, 1.873f, 2.708f, 1.884f, 2.723f, 1.884f)
                close()
                moveTo(2.557f, 2.04f)
                curveTo(2.571f, 2.04f, 2.583f, 2.029f, 2.583f, 2.016f)
                curveTo(2.583f, 2.002f, 2.571f, 1.992f, 2.557f, 1.992f)
                curveTo(2.543f, 1.992f, 2.531f, 2.002f, 2.531f, 2.016f)
                curveTo(2.531f, 2.029f, 2.543f, 2.04f, 2.557f, 2.04f)
                close()
                moveTo(2.64f, 2.196f)
                curveTo(2.654f, 2.196f, 2.665f, 2.185f, 2.665f, 2.172f)
                curveTo(2.665f, 2.158f, 2.654f, 2.148f, 2.64f, 2.148f)
                curveTo(2.626f, 2.148f, 2.614f, 2.158f, 2.614f, 2.172f)
                curveTo(2.614f, 2.185f, 2.626f, 2.196f, 2.64f, 2.196f)
                close()
                moveTo(2.723f, 2.352f)
                curveTo(2.737f, 2.352f, 2.748f, 2.341f, 2.748f, 2.328f)
                curveTo(2.748f, 2.315f, 2.737f, 2.304f, 2.723f, 2.304f)
                curveTo(2.708f, 2.304f, 2.697f, 2.315f, 2.697f, 2.328f)
                curveTo(2.697f, 2.341f, 2.708f, 2.352f, 2.723f, 2.352f)
                close()
                moveTo(2.831f, 2.562f)
                curveTo(2.831f, 2.575f, 2.82f, 2.586f, 2.805f, 2.586f)
                curveTo(2.791f, 2.586f, 2.78f, 2.575f, 2.78f, 2.562f)
                curveTo(2.78f, 2.549f, 2.791f, 2.538f, 2.805f, 2.538f)
                curveTo(2.82f, 2.538f, 2.831f, 2.549f, 2.831f, 2.562f)
                close()
                moveTo(3.054f, 1.65f)
                curveTo(3.068f, 1.65f, 3.079f, 1.639f, 3.079f, 1.626f)
                curveTo(3.079f, 1.612f, 3.068f, 1.601f, 3.054f, 1.601f)
                curveTo(3.04f, 1.601f, 3.028f, 1.612f, 3.028f, 1.626f)
                curveTo(3.028f, 1.639f, 3.04f, 1.65f, 3.054f, 1.65f)
                close()
                moveTo(3.249f, 1.573f)
                curveTo(3.264f, 1.573f, 3.275f, 1.562f, 3.275f, 1.549f)
                curveTo(3.275f, 1.535f, 3.264f, 1.525f, 3.249f, 1.525f)
                curveTo(3.235f, 1.525f, 3.224f, 1.535f, 3.224f, 1.549f)
                curveTo(3.224f, 1.562f, 3.235f, 1.573f, 3.249f, 1.573f)
                close()
                moveTo(3.716f, 1.432f)
                curveTo(3.73f, 1.432f, 3.742f, 1.421f, 3.742f, 1.408f)
                curveTo(3.742f, 1.395f, 3.73f, 1.384f, 3.716f, 1.384f)
                curveTo(3.702f, 1.384f, 3.691f, 1.395f, 3.691f, 1.408f)
                curveTo(3.691f, 1.421f, 3.702f, 1.432f, 3.716f, 1.432f)
                close()
                moveTo(3.965f, 1.338f)
                curveTo(3.979f, 1.338f, 3.99f, 1.327f, 3.99f, 1.313f)
                curveTo(3.99f, 1.3f, 3.979f, 1.289f, 3.965f, 1.289f)
                curveTo(3.951f, 1.289f, 3.939f, 1.3f, 3.939f, 1.313f)
                curveTo(3.939f, 1.327f, 3.951f, 1.338f, 3.965f, 1.338f)
                close()
                moveTo(4.171f, 1.307f)
                curveTo(4.185f, 1.307f, 4.197f, 1.296f, 4.197f, 1.283f)
                curveTo(4.197f, 1.27f, 4.185f, 1.259f, 4.171f, 1.259f)
                curveTo(4.157f, 1.259f, 4.146f, 1.27f, 4.146f, 1.283f)
                curveTo(4.146f, 1.296f, 4.157f, 1.307f, 4.171f, 1.307f)
                close()
                moveTo(4.379f, 1.26f)
                curveTo(4.393f, 1.26f, 4.405f, 1.249f, 4.405f, 1.235f)
                curveTo(4.405f, 1.222f, 4.393f, 1.211f, 4.379f, 1.211f)
                curveTo(4.365f, 1.211f, 4.353f, 1.222f, 4.353f, 1.235f)
                curveTo(4.353f, 1.249f, 4.365f, 1.26f, 4.379f, 1.26f)
                close()
                moveTo(3.468f, 1.806f)
                curveTo(3.482f, 1.806f, 3.494f, 1.795f, 3.494f, 1.782f)
                curveTo(3.494f, 1.768f, 3.482f, 1.757f, 3.468f, 1.757f)
                curveTo(3.454f, 1.757f, 3.442f, 1.768f, 3.442f, 1.782f)
                curveTo(3.442f, 1.795f, 3.454f, 1.806f, 3.468f, 1.806f)
                close()
                moveTo(3.551f, 2.04f)
                curveTo(3.565f, 2.04f, 3.576f, 2.029f, 3.576f, 2.016f)
                curveTo(3.576f, 2.002f, 3.565f, 1.992f, 3.551f, 1.992f)
                curveTo(3.536f, 1.992f, 3.525f, 2.002f, 3.525f, 2.016f)
                curveTo(3.525f, 2.029f, 3.536f, 2.04f, 3.551f, 2.04f)
                close()
                moveTo(3.633f, 2.196f)
                curveTo(3.648f, 2.196f, 3.659f, 2.185f, 3.659f, 2.172f)
                curveTo(3.659f, 2.158f, 3.648f, 2.148f, 3.633f, 2.148f)
                curveTo(3.619f, 2.148f, 3.608f, 2.158f, 3.608f, 2.172f)
                curveTo(3.608f, 2.185f, 3.619f, 2.196f, 3.633f, 2.196f)
                close()
                moveTo(3.716f, 2.352f)
                curveTo(3.73f, 2.352f, 3.742f, 2.341f, 3.742f, 2.328f)
                curveTo(3.742f, 2.315f, 3.73f, 2.304f, 3.716f, 2.304f)
                curveTo(3.702f, 2.304f, 3.691f, 2.315f, 3.691f, 2.328f)
                curveTo(3.691f, 2.341f, 3.702f, 2.352f, 3.716f, 2.352f)
                close()
                moveTo(7.36f, 2.586f)
                curveTo(7.374f, 2.586f, 7.386f, 2.575f, 7.386f, 2.562f)
                curveTo(7.386f, 2.549f, 7.374f, 2.538f, 7.36f, 2.538f)
                curveTo(7.346f, 2.538f, 7.335f, 2.549f, 7.335f, 2.562f)
                curveTo(7.335f, 2.575f, 7.346f, 2.586f, 7.36f, 2.586f)
                close()
                moveTo(7.22f, 2.562f)
                curveTo(7.22f, 2.635f, 7.283f, 2.694f, 7.36f, 2.694f)
                curveTo(7.438f, 2.694f, 7.5f, 2.635f, 7.5f, 2.562f)
                curveTo(7.5f, 2.521f, 7.48f, 2.484f, 7.449f, 2.46f)
                curveTo(7.523f, 2.457f, 7.583f, 2.399f, 7.583f, 2.328f)
                curveTo(7.583f, 2.316f, 7.581f, 2.305f, 7.578f, 2.294f)
                curveTo(7.63f, 2.275f, 7.666f, 2.227f, 7.666f, 2.172f)
                curveTo(7.666f, 2.16f, 7.664f, 2.149f, 7.661f, 2.138f)
                curveTo(7.712f, 2.118f, 7.749f, 2.071f, 7.749f, 2.016f)
                curveTo(7.749f, 1.943f, 7.686f, 1.884f, 7.609f, 1.884f)
                curveTo(7.599f, 1.884f, 7.589f, 1.885f, 7.58f, 1.887f)
                curveTo(7.582f, 1.878f, 7.583f, 1.869f, 7.583f, 1.86f)
                curveTo(7.583f, 1.787f, 7.52f, 1.728f, 7.443f, 1.728f)
                curveTo(7.434f, 1.728f, 7.426f, 1.729f, 7.417f, 1.73f)
                curveTo(7.416f, 1.658f, 7.354f, 1.6f, 7.277f, 1.6f)
                curveTo(7.268f, 1.6f, 7.259f, 1.601f, 7.25f, 1.603f)
                curveTo(7.238f, 1.541f, 7.181f, 1.494f, 7.112f, 1.494f)
                curveTo(7.089f, 1.494f, 7.068f, 1.499f, 7.049f, 1.508f)
                curveTo(7.031f, 1.455f, 6.978f, 1.417f, 6.916f, 1.417f)
                curveTo(6.886f, 1.417f, 6.858f, 1.426f, 6.835f, 1.442f)
                curveTo(6.821f, 1.382f, 6.765f, 1.338f, 6.698f, 1.338f)
                curveTo(6.653f, 1.338f, 6.613f, 1.357f, 6.588f, 1.388f)
                curveTo(6.577f, 1.325f, 6.519f, 1.276f, 6.449f, 1.276f)
                curveTo(6.405f, 1.276f, 6.366f, 1.295f, 6.34f, 1.325f)
                curveTo(6.341f, 1.321f, 6.341f, 1.317f, 6.341f, 1.313f)
                curveTo(6.341f, 1.241f, 6.278f, 1.181f, 6.201f, 1.181f)
                curveTo(6.167f, 1.181f, 6.136f, 1.193f, 6.112f, 1.212f)
                curveTo(6.087f, 1.175f, 6.044f, 1.151f, 5.994f, 1.151f)
                curveTo(5.963f, 1.151f, 5.935f, 1.161f, 5.912f, 1.176f)
                curveTo(5.889f, 1.133f, 5.842f, 1.103f, 5.787f, 1.103f)
                curveTo(5.709f, 1.103f, 5.647f, 1.163f, 5.647f, 1.235f)
                curveTo(5.647f, 1.308f, 5.709f, 1.367f, 5.787f, 1.367f)
                curveTo(5.817f, 1.367f, 5.846f, 1.358f, 5.869f, 1.342f)
                curveTo(5.892f, 1.385f, 5.939f, 1.415f, 5.994f, 1.415f)
                curveTo(6.028f, 1.415f, 6.059f, 1.404f, 6.083f, 1.385f)
                curveTo(6.108f, 1.421f, 6.151f, 1.445f, 6.201f, 1.445f)
                curveTo(6.245f, 1.445f, 6.284f, 1.426f, 6.31f, 1.396f)
                curveTo(6.309f, 1.4f, 6.309f, 1.404f, 6.309f, 1.408f)
                curveTo(6.309f, 1.481f, 6.372f, 1.54f, 6.449f, 1.54f)
                curveTo(6.494f, 1.54f, 6.534f, 1.52f, 6.559f, 1.49f)
                curveTo(6.563f, 1.511f, 6.572f, 1.531f, 6.585f, 1.547f)
                curveTo(6.568f, 1.569f, 6.558f, 1.596f, 6.558f, 1.626f)
                curveTo(6.558f, 1.655f, 6.568f, 1.682f, 6.585f, 1.704f)
                curveTo(6.568f, 1.725f, 6.558f, 1.752f, 6.558f, 1.782f)
                curveTo(6.558f, 1.823f, 6.578f, 1.86f, 6.609f, 1.884f)
                curveTo(6.535f, 1.887f, 6.475f, 1.945f, 6.475f, 2.016f)
                curveTo(6.475f, 2.027f, 6.477f, 2.039f, 6.48f, 2.049f)
                curveTo(6.428f, 2.069f, 6.392f, 2.116f, 6.392f, 2.172f)
                curveTo(6.392f, 2.183f, 6.394f, 2.195f, 6.397f, 2.206f)
                curveTo(6.345f, 2.225f, 6.309f, 2.273f, 6.309f, 2.328f)
                curveTo(6.309f, 2.401f, 6.372f, 2.46f, 6.449f, 2.46f)
                curveTo(6.527f, 2.46f, 6.589f, 2.401f, 6.589f, 2.328f)
                curveTo(6.589f, 2.316f, 6.588f, 2.305f, 6.585f, 2.294f)
                curveTo(6.636f, 2.275f, 6.672f, 2.227f, 6.672f, 2.172f)
                curveTo(6.672f, 2.16f, 6.67f, 2.149f, 6.667f, 2.138f)
                curveTo(6.719f, 2.118f, 6.755f, 2.071f, 6.755f, 2.016f)
                curveTo(6.755f, 1.974f, 6.735f, 1.938f, 6.703f, 1.913f)
                curveTo(6.778f, 1.911f, 6.838f, 1.853f, 6.838f, 1.782f)
                curveTo(6.838f, 1.752f, 6.828f, 1.725f, 6.811f, 1.704f)
                curveTo(6.822f, 1.689f, 6.83f, 1.673f, 6.834f, 1.656f)
                curveTo(6.857f, 1.671f, 6.885f, 1.681f, 6.916f, 1.681f)
                curveTo(6.939f, 1.681f, 6.96f, 1.676f, 6.979f, 1.667f)
                curveTo(6.997f, 1.719f, 7.05f, 1.757f, 7.112f, 1.757f)
                curveTo(7.121f, 1.757f, 7.131f, 1.757f, 7.14f, 1.755f)
                curveTo(7.151f, 1.817f, 7.208f, 1.864f, 7.277f, 1.864f)
                curveTo(7.286f, 1.864f, 7.295f, 1.863f, 7.303f, 1.862f)
                curveTo(7.304f, 1.934f, 7.366f, 1.992f, 7.443f, 1.992f)
                curveTo(7.453f, 1.992f, 7.462f, 1.991f, 7.472f, 1.989f)
                curveTo(7.47f, 1.997f, 7.469f, 2.006f, 7.469f, 2.016f)
                curveTo(7.469f, 2.027f, 7.47f, 2.039f, 7.473f, 2.049f)
                curveTo(7.422f, 2.069f, 7.386f, 2.116f, 7.386f, 2.172f)
                curveTo(7.386f, 2.183f, 7.387f, 2.195f, 7.391f, 2.206f)
                curveTo(7.339f, 2.225f, 7.303f, 2.273f, 7.303f, 2.328f)
                curveTo(7.303f, 2.369f, 7.323f, 2.406f, 7.355f, 2.43f)
                curveTo(7.28f, 2.433f, 7.22f, 2.491f, 7.22f, 2.562f)
                close()
                moveTo(6.779f, 1.577f)
                curveTo(6.756f, 1.592f, 6.728f, 1.601f, 6.698f, 1.601f)
                curveTo(6.651f, 1.601f, 6.61f, 1.58f, 6.585f, 1.547f)
                curveTo(6.61f, 1.515f, 6.651f, 1.494f, 6.698f, 1.494f)
                curveTo(6.728f, 1.494f, 6.757f, 1.503f, 6.78f, 1.519f)
                curveTo(6.777f, 1.528f, 6.776f, 1.538f, 6.776f, 1.549f)
                curveTo(6.776f, 1.558f, 6.777f, 1.568f, 6.779f, 1.577f)
                close()
                moveTo(6.811f, 1.547f)
                curveTo(6.828f, 1.569f, 6.838f, 1.596f, 6.838f, 1.626f)
                curveTo(6.838f, 1.636f, 6.836f, 1.646f, 6.834f, 1.656f)
                curveTo(6.807f, 1.637f, 6.787f, 1.609f, 6.779f, 1.577f)
                curveTo(6.791f, 1.568f, 6.802f, 1.559f, 6.811f, 1.547f)
                close()
                moveTo(6.811f, 1.547f)
                curveTo(6.802f, 1.536f, 6.792f, 1.527f, 6.78f, 1.519f)
                curveTo(6.788f, 1.487f, 6.807f, 1.46f, 6.835f, 1.442f)
                curveTo(6.837f, 1.451f, 6.838f, 1.46f, 6.838f, 1.469f)
                curveTo(6.838f, 1.499f, 6.828f, 1.526f, 6.811f, 1.547f)
                close()
                moveTo(6.585f, 2.294f)
                curveTo(6.569f, 2.238f, 6.514f, 2.196f, 6.449f, 2.196f)
                curveTo(6.431f, 2.196f, 6.413f, 2.199f, 6.397f, 2.206f)
                curveTo(6.413f, 2.262f, 6.467f, 2.304f, 6.532f, 2.304f)
                curveTo(6.551f, 2.304f, 6.568f, 2.3f, 6.585f, 2.294f)
                close()
                moveTo(6.667f, 2.138f)
                curveTo(6.652f, 2.082f, 6.597f, 2.04f, 6.532f, 2.04f)
                curveTo(6.513f, 2.04f, 6.496f, 2.043f, 6.48f, 2.049f)
                curveTo(6.495f, 2.106f, 6.55f, 2.148f, 6.615f, 2.148f)
                curveTo(6.633f, 2.148f, 6.651f, 2.144f, 6.667f, 2.138f)
                close()
                moveTo(6.703f, 1.913f)
                curveTo(6.679f, 1.895f, 6.648f, 1.884f, 6.615f, 1.884f)
                lineTo(6.609f, 1.884f)
                curveTo(6.633f, 1.902f, 6.664f, 1.913f, 6.698f, 1.913f)
                lineTo(6.703f, 1.913f)
                close()
                moveTo(6.811f, 1.704f)
                curveTo(6.785f, 1.671f, 6.744f, 1.65f, 6.698f, 1.65f)
                curveTo(6.651f, 1.65f, 6.61f, 1.671f, 6.585f, 1.704f)
                curveTo(6.61f, 1.736f, 6.651f, 1.757f, 6.698f, 1.757f)
                curveTo(6.744f, 1.757f, 6.785f, 1.736f, 6.811f, 1.704f)
                close()
                moveTo(5.869f, 1.342f)
                curveTo(5.904f, 1.318f, 5.927f, 1.279f, 5.927f, 1.235f)
                curveTo(5.927f, 1.214f, 5.921f, 1.194f, 5.912f, 1.176f)
                curveTo(5.877f, 1.2f, 5.854f, 1.239f, 5.854f, 1.283f)
                curveTo(5.854f, 1.304f, 5.86f, 1.324f, 5.869f, 1.342f)
                close()
                moveTo(6.083f, 1.385f)
                curveTo(6.114f, 1.361f, 6.134f, 1.324f, 6.134f, 1.283f)
                curveTo(6.134f, 1.257f, 6.126f, 1.232f, 6.112f, 1.212f)
                curveTo(6.081f, 1.236f, 6.061f, 1.272f, 6.061f, 1.313f)
                curveTo(6.061f, 1.34f, 6.069f, 1.364f, 6.083f, 1.385f)
                close()
                moveTo(6.34f, 1.325f)
                curveTo(6.338f, 1.352f, 6.327f, 1.376f, 6.31f, 1.396f)
                curveTo(6.312f, 1.369f, 6.323f, 1.345f, 6.34f, 1.325f)
                close()
                moveTo(6.559f, 1.49f)
                curveTo(6.578f, 1.467f, 6.589f, 1.439f, 6.589f, 1.408f)
                curveTo(6.589f, 1.401f, 6.589f, 1.395f, 6.588f, 1.388f)
                curveTo(6.569f, 1.41f, 6.558f, 1.439f, 6.558f, 1.469f)
                curveTo(6.558f, 1.476f, 6.558f, 1.483f, 6.559f, 1.49f)
                close()
                moveTo(6.979f, 1.667f)
                curveTo(7.025f, 1.645f, 7.056f, 1.6f, 7.056f, 1.549f)
                curveTo(7.056f, 1.534f, 7.054f, 1.52f, 7.049f, 1.508f)
                curveTo(7.003f, 1.529f, 6.972f, 1.574f, 6.972f, 1.626f)
                curveTo(6.972f, 1.64f, 6.974f, 1.654f, 6.979f, 1.667f)
                close()
                moveTo(7.14f, 1.755f)
                curveTo(7.204f, 1.743f, 7.252f, 1.689f, 7.252f, 1.626f)
                curveTo(7.252f, 1.618f, 7.251f, 1.61f, 7.25f, 1.603f)
                curveTo(7.186f, 1.615f, 7.137f, 1.668f, 7.137f, 1.732f)
                curveTo(7.137f, 1.74f, 7.138f, 1.747f, 7.14f, 1.755f)
                close()
                moveTo(7.472f, 1.989f)
                curveTo(7.526f, 1.978f, 7.569f, 1.938f, 7.58f, 1.887f)
                curveTo(7.526f, 1.897f, 7.483f, 1.938f, 7.472f, 1.989f)
                close()
                moveTo(7.417f, 1.73f)
                lineTo(7.417f, 1.732f)
                curveTo(7.417f, 1.797f, 7.368f, 1.85f, 7.303f, 1.862f)
                lineTo(7.303f, 1.86f)
                curveTo(7.303f, 1.795f, 7.352f, 1.741f, 7.417f, 1.73f)
                close()
                moveTo(7.473f, 2.049f)
                curveTo(7.49f, 2.043f, 7.507f, 2.04f, 7.526f, 2.04f)
                curveTo(7.591f, 2.04f, 7.645f, 2.082f, 7.661f, 2.138f)
                curveTo(7.645f, 2.144f, 7.627f, 2.148f, 7.609f, 2.148f)
                curveTo(7.544f, 2.148f, 7.489f, 2.106f, 7.473f, 2.049f)
                close()
                moveTo(7.391f, 2.206f)
                curveTo(7.407f, 2.199f, 7.424f, 2.196f, 7.443f, 2.196f)
                curveTo(7.508f, 2.196f, 7.563f, 2.238f, 7.578f, 2.294f)
                curveTo(7.562f, 2.3f, 7.544f, 2.304f, 7.526f, 2.304f)
                curveTo(7.461f, 2.304f, 7.406f, 2.262f, 7.391f, 2.206f)
                close()
                moveTo(7.443f, 2.46f)
                curveTo(7.41f, 2.46f, 7.379f, 2.449f, 7.355f, 2.43f)
                lineTo(7.36f, 2.43f)
                curveTo(7.394f, 2.43f, 7.424f, 2.441f, 7.449f, 2.46f)
                lineTo(7.443f, 2.46f)
                close()
                moveTo(7.443f, 2.352f)
                curveTo(7.457f, 2.352f, 7.469f, 2.341f, 7.469f, 2.328f)
                curveTo(7.469f, 2.315f, 7.457f, 2.304f, 7.443f, 2.304f)
                curveTo(7.429f, 2.304f, 7.417f, 2.315f, 7.417f, 2.328f)
                curveTo(7.417f, 2.341f, 7.429f, 2.352f, 7.443f, 2.352f)
                close()
                moveTo(7.526f, 2.196f)
                curveTo(7.54f, 2.196f, 7.552f, 2.185f, 7.552f, 2.172f)
                curveTo(7.552f, 2.158f, 7.54f, 2.148f, 7.526f, 2.148f)
                curveTo(7.512f, 2.148f, 7.5f, 2.158f, 7.5f, 2.172f)
                curveTo(7.5f, 2.185f, 7.512f, 2.196f, 7.526f, 2.196f)
                close()
                moveTo(7.609f, 2.04f)
                curveTo(7.623f, 2.04f, 7.634f, 2.029f, 7.634f, 2.016f)
                curveTo(7.634f, 2.002f, 7.623f, 1.992f, 7.609f, 1.992f)
                curveTo(7.594f, 1.992f, 7.583f, 2.002f, 7.583f, 2.016f)
                curveTo(7.583f, 2.029f, 7.594f, 2.04f, 7.609f, 2.04f)
                close()
                moveTo(7.443f, 1.884f)
                curveTo(7.457f, 1.884f, 7.469f, 1.873f, 7.469f, 1.86f)
                curveTo(7.469f, 1.846f, 7.457f, 1.835f, 7.443f, 1.835f)
                curveTo(7.429f, 1.835f, 7.417f, 1.846f, 7.417f, 1.86f)
                curveTo(7.417f, 1.873f, 7.429f, 1.884f, 7.443f, 1.884f)
                close()
                moveTo(7.277f, 1.756f)
                curveTo(7.292f, 1.756f, 7.303f, 1.745f, 7.303f, 1.732f)
                curveTo(7.303f, 1.719f, 7.292f, 1.708f, 7.277f, 1.708f)
                curveTo(7.263f, 1.708f, 7.252f, 1.719f, 7.252f, 1.732f)
                curveTo(7.252f, 1.745f, 7.263f, 1.756f, 7.277f, 1.756f)
                close()
                moveTo(7.112f, 1.65f)
                curveTo(7.126f, 1.65f, 7.137f, 1.639f, 7.137f, 1.626f)
                curveTo(7.137f, 1.612f, 7.126f, 1.601f, 7.112f, 1.601f)
                curveTo(7.098f, 1.601f, 7.086f, 1.612f, 7.086f, 1.626f)
                curveTo(7.086f, 1.639f, 7.098f, 1.65f, 7.112f, 1.65f)
                close()
                moveTo(6.916f, 1.573f)
                curveTo(6.93f, 1.573f, 6.942f, 1.562f, 6.942f, 1.549f)
                curveTo(6.942f, 1.535f, 6.93f, 1.525f, 6.916f, 1.525f)
                curveTo(6.902f, 1.525f, 6.891f, 1.535f, 6.891f, 1.549f)
                curveTo(6.891f, 1.562f, 6.902f, 1.573f, 6.916f, 1.573f)
                close()
                moveTo(6.698f, 1.494f)
                curveTo(6.712f, 1.494f, 6.723f, 1.483f, 6.723f, 1.469f)
                curveTo(6.723f, 1.456f, 6.712f, 1.445f, 6.698f, 1.445f)
                curveTo(6.683f, 1.445f, 6.672f, 1.456f, 6.672f, 1.469f)
                curveTo(6.672f, 1.483f, 6.683f, 1.494f, 6.698f, 1.494f)
                close()
                moveTo(6.449f, 1.432f)
                curveTo(6.463f, 1.432f, 6.475f, 1.421f, 6.475f, 1.408f)
                curveTo(6.475f, 1.395f, 6.463f, 1.384f, 6.449f, 1.384f)
                curveTo(6.435f, 1.384f, 6.424f, 1.395f, 6.424f, 1.408f)
                curveTo(6.424f, 1.421f, 6.435f, 1.432f, 6.449f, 1.432f)
                close()
                moveTo(6.201f, 1.338f)
                curveTo(6.215f, 1.338f, 6.226f, 1.327f, 6.226f, 1.313f)
                curveTo(6.226f, 1.3f, 6.215f, 1.289f, 6.201f, 1.289f)
                curveTo(6.187f, 1.289f, 6.175f, 1.3f, 6.175f, 1.313f)
                curveTo(6.175f, 1.327f, 6.187f, 1.338f, 6.201f, 1.338f)
                close()
                moveTo(5.994f, 1.307f)
                curveTo(6.008f, 1.307f, 6.02f, 1.296f, 6.02f, 1.283f)
                curveTo(6.02f, 1.27f, 6.008f, 1.259f, 5.994f, 1.259f)
                curveTo(5.98f, 1.259f, 5.969f, 1.27f, 5.969f, 1.283f)
                curveTo(5.969f, 1.296f, 5.98f, 1.307f, 5.994f, 1.307f)
                close()
                moveTo(5.787f, 1.26f)
                curveTo(5.801f, 1.26f, 5.812f, 1.249f, 5.812f, 1.235f)
                curveTo(5.812f, 1.222f, 5.801f, 1.211f, 5.787f, 1.211f)
                curveTo(5.773f, 1.211f, 5.761f, 1.222f, 5.761f, 1.235f)
                curveTo(5.761f, 1.249f, 5.773f, 1.26f, 5.787f, 1.26f)
                close()
                moveTo(6.698f, 1.65f)
                curveTo(6.712f, 1.65f, 6.723f, 1.639f, 6.723f, 1.626f)
                curveTo(6.723f, 1.612f, 6.712f, 1.601f, 6.698f, 1.601f)
                curveTo(6.683f, 1.601f, 6.672f, 1.612f, 6.672f, 1.626f)
                curveTo(6.672f, 1.639f, 6.683f, 1.65f, 6.698f, 1.65f)
                close()
                moveTo(6.698f, 1.806f)
                curveTo(6.712f, 1.806f, 6.723f, 1.795f, 6.723f, 1.782f)
                curveTo(6.723f, 1.768f, 6.712f, 1.757f, 6.698f, 1.757f)
                curveTo(6.683f, 1.757f, 6.672f, 1.768f, 6.672f, 1.782f)
                curveTo(6.672f, 1.795f, 6.683f, 1.806f, 6.698f, 1.806f)
                close()
                moveTo(6.615f, 2.04f)
                curveTo(6.629f, 2.04f, 6.641f, 2.029f, 6.641f, 2.016f)
                curveTo(6.641f, 2.002f, 6.629f, 1.992f, 6.615f, 1.992f)
                curveTo(6.601f, 1.992f, 6.589f, 2.002f, 6.589f, 2.016f)
                curveTo(6.589f, 2.029f, 6.601f, 2.04f, 6.615f, 2.04f)
                close()
                moveTo(6.532f, 2.196f)
                curveTo(6.546f, 2.196f, 6.558f, 2.185f, 6.558f, 2.172f)
                curveTo(6.558f, 2.158f, 6.546f, 2.148f, 6.532f, 2.148f)
                curveTo(6.518f, 2.148f, 6.506f, 2.158f, 6.506f, 2.172f)
                curveTo(6.506f, 2.185f, 6.518f, 2.196f, 6.532f, 2.196f)
                close()
                moveTo(6.449f, 2.352f)
                curveTo(6.463f, 2.352f, 6.475f, 2.341f, 6.475f, 2.328f)
                curveTo(6.475f, 2.315f, 6.463f, 2.304f, 6.449f, 2.304f)
                curveTo(6.435f, 2.304f, 6.424f, 2.315f, 6.424f, 2.328f)
                curveTo(6.424f, 2.341f, 6.435f, 2.352f, 6.449f, 2.352f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6C540)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.11f, 0.461f)
                lineTo(4.891f, 0.467f)
                lineTo(4.887f, 0.808f)
                lineTo(4.483f, 0.814f)
                lineTo(4.485f, 1.021f)
                lineTo(4.884f, 1.016f)
                lineTo(4.879f, 1.405f)
                lineTo(5.098f, 1.398f)
                lineTo(5.103f, 1.013f)
                lineTo(5.5f, 1.007f)
                lineTo(5.499f, 0.8f)
                lineTo(5.106f, 0.805f)
                lineTo(5.11f, 0.461f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.02f, 4.003f)
                horizontalLineTo(7.963f)
                verticalLineTo(8.759f)
                curveTo(7.963f, 8.759f, 7.783f, 11.129f, 4.991f, 11.129f)
                curveTo(2.2f, 11.129f, 2.02f, 8.759f, 2.02f, 8.759f)
                verticalLineTo(4.003f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.813f, 4.168f)
                curveTo(3.759f, 4.168f, 3.675f, 4.204f, 3.564f, 4.246f)
                curveTo(3.453f, 4.288f, 3.336f, 4.378f, 3.45f, 4.468f)
                curveTo(3.564f, 4.559f, 3.727f, 4.757f, 3.727f, 4.683f)
                curveTo(3.727f, 4.609f, 3.922f, 4.537f, 3.922f, 4.573f)
                curveTo(3.922f, 4.609f, 3.862f, 4.683f, 4.02f, 4.683f)
                curveTo(4.178f, 4.683f, 4.26f, 4.727f, 4.091f, 4.727f)
                curveTo(3.922f, 4.727f, 3.904f, 4.8f, 3.794f, 4.8f)
                curveTo(3.684f, 4.8f, 3.45f, 4.726f, 3.45f, 4.683f)
                curveTo(3.45f, 4.639f, 3.586f, 4.897f, 3.727f, 4.897f)
                curveTo(3.869f, 4.897f, 3.949f, 5.022f, 4.02f, 4.959f)
                curveTo(4.091f, 4.897f, 4.083f, 4.897f, 4.197f, 4.897f)
                curveTo(4.312f, 4.897f, 4.27f, 4.644f, 4.27f, 4.644f)
                curveTo(4.27f, 4.644f, 3.868f, 4.168f, 3.813f, 4.168f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.107f, 4.168f)
                curveTo(6.161f, 4.168f, 6.245f, 4.204f, 6.356f, 4.246f)
                curveTo(6.468f, 4.288f, 6.584f, 4.378f, 6.47f, 4.468f)
                curveTo(6.356f, 4.559f, 6.193f, 4.757f, 6.193f, 4.683f)
                curveTo(6.193f, 4.609f, 5.998f, 4.537f, 5.998f, 4.573f)
                curveTo(5.998f, 4.609f, 6.059f, 4.683f, 5.9f, 4.683f)
                curveTo(5.742f, 4.683f, 5.661f, 4.727f, 5.829f, 4.727f)
                curveTo(5.998f, 4.727f, 6.017f, 4.8f, 6.126f, 4.8f)
                curveTo(6.236f, 4.8f, 6.47f, 4.726f, 6.47f, 4.683f)
                curveTo(6.47f, 4.639f, 6.335f, 4.897f, 6.193f, 4.897f)
                curveTo(6.052f, 4.897f, 5.971f, 5.022f, 5.9f, 4.959f)
                curveTo(5.829f, 4.897f, 5.838f, 4.897f, 5.723f, 4.897f)
                curveTo(5.609f, 4.897f, 5.65f, 4.644f, 5.65f, 4.644f)
                curveTo(5.65f, 4.644f, 6.052f, 4.168f, 6.107f, 4.168f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.835f, 4.685f)
                curveTo(6.949f, 4.935f, 6.076f, 5.865f, 6.076f, 5.865f)
                horizontalLineTo(5.978f)
                curveTo(5.937f, 5.865f, 5.861f, 5.77f, 5.769f, 5.655f)
                curveTo(5.705f, 5.576f, 5.635f, 5.488f, 5.563f, 5.415f)
                curveTo(5.428f, 5.277f, 5.499f, 5.162f, 5.566f, 5.054f)
                curveTo(5.587f, 5.021f, 5.607f, 4.989f, 5.62f, 4.957f)
                curveTo(5.649f, 4.887f, 5.653f, 4.86f, 5.658f, 4.828f)
                curveTo(5.663f, 4.798f, 5.668f, 4.763f, 5.697f, 4.685f)
                curveTo(5.739f, 4.569f, 5.885f, 4.42f, 5.987f, 4.316f)
                curveTo(6.026f, 4.276f, 6.059f, 4.243f, 6.076f, 4.221f)
                curveTo(6.131f, 4.153f, 6.089f, 4.153f, 5.976f, 4.154f)
                curveTo(5.96f, 4.154f, 5.943f, 4.155f, 5.925f, 4.155f)
                curveTo(5.773f, 4.155f, 5.484f, 4.221f, 5.398f, 4.299f)
                curveTo(5.311f, 4.378f, 5.221f, 4.394f, 5.088f, 4.394f)
                curveTo(4.954f, 4.394f, 5.037f, 4.479f, 5.158f, 4.536f)
                curveTo(5.027f, 4.559f, 4.944f, 4.764f, 4.894f, 4.947f)
                curveTo(4.868f, 4.764f, 4.808f, 4.559f, 4.678f, 4.536f)
                curveTo(4.799f, 4.479f, 4.881f, 4.394f, 4.748f, 4.394f)
                curveTo(4.615f, 4.394f, 4.524f, 4.378f, 4.438f, 4.299f)
                curveTo(4.351f, 4.221f, 4.062f, 4.155f, 3.911f, 4.155f)
                curveTo(3.893f, 4.155f, 3.876f, 4.154f, 3.86f, 4.154f)
                curveTo(3.746f, 4.153f, 3.705f, 4.153f, 3.759f, 4.221f)
                curveTo(3.777f, 4.243f, 3.809f, 4.276f, 3.849f, 4.316f)
                curveTo(3.95f, 4.42f, 4.097f, 4.569f, 4.139f, 4.685f)
                curveTo(4.168f, 4.763f, 4.173f, 4.798f, 4.177f, 4.828f)
                curveTo(4.182f, 4.86f, 4.186f, 4.887f, 4.215f, 4.957f)
                curveTo(4.229f, 4.989f, 4.249f, 5.021f, 4.269f, 5.054f)
                curveTo(4.336f, 5.162f, 4.408f, 5.277f, 4.273f, 5.415f)
                curveTo(4.201f, 5.488f, 4.13f, 5.576f, 4.067f, 5.655f)
                curveTo(3.975f, 5.77f, 3.898f, 5.865f, 3.857f, 5.865f)
                horizontalLineTo(3.759f)
                curveTo(3.759f, 5.865f, 2.886f, 4.935f, 3f, 4.685f)
                curveTo(3.044f, 4.588f, 3.115f, 4.497f, 3.174f, 4.421f)
                curveTo(3.267f, 4.302f, 3.33f, 4.221f, 3.205f, 4.221f)
                curveTo(3f, 4.221f, 2.186f, 4.708f, 2.186f, 5.805f)
                curveTo(2.186f, 6.902f, 2.261f, 7.526f, 2.436f, 7.963f)
                curveTo(2.555f, 8.261f, 2.446f, 8.551f, 2.365f, 8.767f)
                curveTo(2.327f, 8.867f, 2.295f, 8.952f, 2.295f, 9.013f)
                curveTo(2.295f, 9.209f, 2.615f, 9.038f, 2.615f, 8.915f)
                curveTo(2.615f, 8.857f, 2.659f, 8.944f, 2.705f, 9.035f)
                curveTo(2.756f, 9.135f, 2.81f, 9.24f, 2.81f, 9.162f)
                curveTo(2.81f, 9.079f, 2.861f, 8.991f, 2.906f, 8.914f)
                curveTo(2.941f, 8.853f, 2.973f, 8.799f, 2.973f, 8.758f)
                curveTo(2.973f, 8.718f, 3.018f, 8.719f, 3.068f, 8.721f)
                curveTo(3.132f, 8.723f, 3.205f, 8.725f, 3.205f, 8.642f)
                curveTo(3.205f, 8.586f, 3.228f, 8.575f, 3.256f, 8.561f)
                curveTo(3.304f, 8.538f, 3.367f, 8.508f, 3.367f, 8.256f)
                curveTo(3.367f, 8.07f, 3.406f, 8.136f, 3.452f, 8.212f)
                curveTo(3.493f, 8.281f, 3.54f, 8.359f, 3.565f, 8.256f)
                curveTo(3.568f, 8.246f, 3.594f, 8.203f, 3.626f, 8.15f)
                curveTo(3.674f, 8.072f, 3.734f, 7.973f, 3.753f, 7.922f)
                curveTo(3.694f, 8.142f, 3.551f, 8.37f, 3.46f, 8.479f)
                curveTo(3.367f, 8.592f, 3.205f, 8.837f, 3.205f, 8.837f)
                curveTo(3.205f, 8.837f, 3.356f, 8.917f, 3.46f, 8.837f)
                curveTo(3.519f, 8.793f, 3.523f, 8.835f, 3.527f, 8.88f)
                curveTo(3.531f, 8.916f, 3.534f, 8.955f, 3.565f, 8.955f)
                curveTo(3.585f, 8.955f, 3.603f, 8.958f, 3.619f, 8.96f)
                curveTo(3.632f, 8.962f, 3.642f, 8.964f, 3.652f, 8.964f)
                curveTo(3.617f, 9.048f, 3.586f, 9.183f, 3.691f, 9.093f)
                curveTo(3.766f, 9.029f, 3.819f, 9.003f, 3.854f, 8.986f)
                curveTo(3.894f, 8.966f, 3.911f, 8.957f, 3.911f, 8.915f)
                curveTo(3.911f, 8.874f, 3.927f, 8.888f, 3.953f, 8.91f)
                curveTo(3.975f, 8.929f, 4.005f, 8.955f, 4.036f, 8.955f)
                curveTo(4.077f, 8.955f, 4.086f, 8.901f, 4.098f, 8.823f)
                curveTo(4.106f, 8.771f, 4.116f, 8.708f, 4.139f, 8.642f)
                curveTo(4.144f, 8.627f, 4.149f, 8.612f, 4.154f, 8.598f)
                curveTo(4.2f, 8.464f, 4.221f, 8.401f, 4.273f, 8.571f)
                curveTo(4.297f, 8.65f, 4.34f, 8.706f, 4.377f, 8.755f)
                curveTo(4.428f, 8.822f, 4.468f, 8.875f, 4.438f, 8.955f)
                curveTo(4.426f, 8.986f, 4.411f, 9.021f, 4.395f, 9.059f)
                curveTo(4.34f, 9.188f, 4.273f, 9.347f, 4.273f, 9.472f)
                curveTo(4.273f, 9.547f, 4.201f, 9.648f, 4.133f, 9.743f)
                curveTo(4.054f, 9.855f, 3.981f, 9.958f, 4.036f, 10f)
                curveTo(4.139f, 10.077f, 4.015f, 10.337f, 3.911f, 10.47f)
                curveTo(3.807f, 10.603f, 4.678f, 10.909f, 4.83f, 10.909f)
                curveTo(4.832f, 10.909f, 4.834f, 10.908f, 4.836f, 10.906f)
                verticalLineTo(10.909f)
                curveTo(4.836f, 10.909f, 5.925f, 10.859f, 5.925f, 10.47f)
                curveTo(5.821f, 10.337f, 5.697f, 10.077f, 5.799f, 10f)
                curveTo(5.855f, 9.958f, 5.781f, 9.855f, 5.702f, 9.743f)
                curveTo(5.635f, 9.648f, 5.563f, 9.547f, 5.563f, 9.472f)
                curveTo(5.563f, 9.347f, 5.496f, 9.188f, 5.441f, 9.059f)
                curveTo(5.425f, 9.021f, 5.41f, 8.986f, 5.398f, 8.955f)
                curveTo(5.367f, 8.875f, 5.408f, 8.822f, 5.459f, 8.755f)
                curveTo(5.496f, 8.706f, 5.539f, 8.65f, 5.563f, 8.571f)
                curveTo(5.615f, 8.401f, 5.636f, 8.464f, 5.682f, 8.598f)
                curveTo(5.686f, 8.612f, 5.691f, 8.627f, 5.697f, 8.642f)
                curveTo(5.719f, 8.708f, 5.729f, 8.771f, 5.738f, 8.823f)
                curveTo(5.75f, 8.901f, 5.758f, 8.955f, 5.799f, 8.955f)
                curveTo(5.831f, 8.955f, 5.86f, 8.929f, 5.883f, 8.91f)
                curveTo(5.908f, 8.888f, 5.925f, 8.874f, 5.925f, 8.915f)
                curveTo(5.925f, 8.957f, 5.941f, 8.966f, 5.982f, 8.986f)
                curveTo(6.017f, 9.003f, 6.069f, 9.029f, 6.145f, 9.093f)
                curveTo(6.25f, 9.183f, 6.219f, 9.048f, 6.184f, 8.964f)
                curveTo(6.193f, 8.964f, 6.204f, 8.962f, 6.216f, 8.96f)
                curveTo(6.233f, 8.958f, 6.251f, 8.955f, 6.27f, 8.955f)
                curveTo(6.301f, 8.955f, 6.305f, 8.916f, 6.308f, 8.88f)
                curveTo(6.313f, 8.835f, 6.317f, 8.793f, 6.375f, 8.837f)
                curveTo(6.48f, 8.917f, 6.631f, 8.837f, 6.631f, 8.837f)
                curveTo(6.631f, 8.837f, 6.469f, 8.592f, 6.375f, 8.479f)
                curveTo(6.285f, 8.37f, 6.142f, 8.142f, 6.082f, 7.922f)
                curveTo(6.102f, 7.973f, 6.162f, 8.072f, 6.209f, 8.15f)
                curveTo(6.242f, 8.203f, 6.268f, 8.246f, 6.27f, 8.256f)
                curveTo(6.296f, 8.359f, 6.342f, 8.281f, 6.384f, 8.212f)
                curveTo(6.43f, 8.136f, 6.469f, 8.07f, 6.469f, 8.256f)
                curveTo(6.469f, 8.508f, 6.532f, 8.538f, 6.579f, 8.561f)
                curveTo(6.608f, 8.575f, 6.631f, 8.586f, 6.631f, 8.642f)
                curveTo(6.631f, 8.725f, 6.704f, 8.723f, 6.768f, 8.721f)
                curveTo(6.818f, 8.719f, 6.863f, 8.718f, 6.863f, 8.758f)
                curveTo(6.863f, 8.799f, 6.895f, 8.853f, 6.93f, 8.914f)
                curveTo(6.975f, 8.991f, 7.026f, 9.079f, 7.026f, 9.162f)
                curveTo(7.026f, 9.24f, 7.079f, 9.135f, 7.13f, 9.035f)
                curveTo(7.176f, 8.944f, 7.22f, 8.857f, 7.22f, 8.915f)
                curveTo(7.22f, 9.038f, 7.541f, 9.209f, 7.541f, 9.013f)
                curveTo(7.541f, 8.952f, 7.509f, 8.867f, 7.471f, 8.767f)
                curveTo(7.39f, 8.551f, 7.281f, 8.261f, 7.4f, 7.963f)
                curveTo(7.574f, 7.526f, 7.65f, 6.902f, 7.65f, 5.805f)
                curveTo(7.65f, 4.708f, 6.835f, 4.221f, 6.631f, 4.221f)
                curveTo(6.506f, 4.221f, 6.568f, 4.302f, 6.662f, 4.421f)
                curveTo(6.72f, 4.497f, 6.791f, 4.588f, 6.835f, 4.685f)
                close()
                moveTo(6.076f, 7.898f)
                curveTo(6.078f, 7.906f, 6.08f, 7.914f, 6.082f, 7.922f)
                curveTo(6.078f, 7.912f, 6.076f, 7.904f, 6.076f, 7.898f)
                close()
                moveTo(6.145f, 8.915f)
                curveTo(6.145f, 8.888f, 6.165f, 8.919f, 6.184f, 8.964f)
                curveTo(6.16f, 8.965f, 6.145f, 8.956f, 6.145f, 8.915f)
                close()
                moveTo(3.652f, 8.964f)
                curveTo(3.676f, 8.965f, 3.691f, 8.956f, 3.691f, 8.915f)
                curveTo(3.691f, 8.888f, 3.671f, 8.919f, 3.652f, 8.964f)
                close()
                moveTo(3.753f, 7.922f)
                curveTo(3.757f, 7.912f, 3.759f, 7.904f, 3.759f, 7.898f)
                curveTo(3.758f, 7.906f, 3.755f, 7.914f, 3.753f, 7.922f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.884f, 5.942f)
                horizontalLineTo(6.099f)
                verticalLineTo(7.591f)
                curveTo(6.099f, 7.591f, 5.861f, 8.412f, 4.991f, 8.412f)
                curveTo(4.122f, 8.412f, 3.884f, 7.591f, 3.884f, 7.591f)
                verticalLineTo(5.942f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.29f, 5.918f)
                horizontalLineTo(4.71f)
                verticalLineTo(6.864f)
                horizontalLineTo(3.882f)
                verticalLineTo(7.203f)
                horizontalLineTo(4.71f)
                verticalLineTo(8.42f)
                horizontalLineTo(5.29f)
                verticalLineTo(7.203f)
                horizontalLineTo(6.118f)
                verticalLineTo(6.864f)
                horizontalLineTo(5.29f)
                verticalLineTo(5.918f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.437f, 9.663f)
                curveTo(3.706f, 9.354f, 3.958f, 9.078f, 3.734f, 8.883f)
                curveTo(3.509f, 8.688f, 3.241f, 8.857f, 2.972f, 9.167f)
                curveTo(2.703f, 9.477f, 2.535f, 9.81f, 2.759f, 10.005f)
                curveTo(2.984f, 10.2f, 3.168f, 9.973f, 3.437f, 9.663f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.368f, 9.663f)
                curveTo(6.099f, 9.354f, 5.846f, 9.078f, 6.071f, 8.883f)
                curveTo(6.295f, 8.688f, 6.563f, 8.857f, 6.832f, 9.167f)
                curveTo(7.102f, 9.477f, 7.27f, 9.81f, 7.046f, 10.005f)
                curveTo(6.821f, 10.2f, 6.637f, 9.973f, 6.368f, 9.663f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun SerbiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Serbia,
            contentDescription = "Serbia Flag"
        )
    }
}
